module.exports = __webpack_public_path__ + "static/media/icon-settings-biil-dot-com.8f32eb97.svg";